export const FIRST_LIST = [
    {
        number: "01",
        header: "Personal information",
        text: "We may collect personal information, such as your name, email address, contact number, and job title, when you voluntarily provide it to us through our website or during the course of our business interactions.",
    },
    {
        number: "02",
        header: "Usage data",
        text: "We may collect non-personal information about your visit to our website, including your IP address, browser type, operating system, referring/exit pages, and the date/time of your visit. This information is used to analyze trends, administer the site, track user movements, and gather demographic information.",
    },
]

export const SECOND_LIST = [
    {
        number: "01",
        header: "Personal information",
        text: "We may use your personal information to:",
        points: [
            "Provide and improve our services",
            "Respond to your inquiries and fulfill your requests",
            "Communicate with you about our products, services, and updates",
            "Process transactions and send you related information",
            "Personalize your experience on our website",
            "Conduct research and analysis to enhance our offerings",
            "Comply with applicable laws and regulations",
        ]
    },
    {
        number: "02",
        header: "Usage data",
        text: "We may use non-personal information to:",
        points: [
            "Analyze trends",
            "Administer our website",
            "Track user movements",
            "Gather demographic information"
        ],
        next: "This data helps us improve our website and tailor it to our visitors' needs."
    },
]

export const THIRD_LIST = [
    {
        number: "01",
        header: "Service Providers",
        text: "We may share your personal information with trusted third-party service providers who assist us in operating our business and providing our services. These providers are obligated to use your information only for the purposes specified by us and in accordance with this Privacy Policy.",
    },
    {
        number: "02",
        header: "Legal Requirements",
        text: "We may disclose your personal information if required to do so by law or in response to valid requests by public authorities (e.g., a court or government agency).",
    },
]

export const UNORDERED_LIST = [
    {
        header: "Data Security",
        text: "We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, please note that no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security.",
    },
    {
        header: "Your Choices",
        text: "You have the right to access, correct, update, or delete your personal information. You may also opt-out of receiving promotional communications from us by following the instructions in those communications. Please note that even if you opt-out, we may still send you non-promotional messages related to your transactions or our ongoing business relationship.",
    },
    {
        header: "Third-Party Links",
        text: "Our website may contain links to third-party websites or services. We are not responsible for the privacy practices or the content of such websites. We encourage you to review the privacy policies of those third parties before providing any personal information.",
    },
    {
        header: "Changes to this Privacy Policy",
        text: "We reserve the right to modify or update this Privacy Policy at any time. We will post the revised version on our website with the updated effective date. We encourage you to review this Privacy Policy periodically for any changes.",
    },
    {
        header: "Contact Us",
        text: "If you have any questions or concerns about our Privacy Policy or the way we handle your personal information, please contact us at support@newsoft-ns.com.",
    },
]
